import React, { useEffect, useState, useCallback } from 'react';

//Bootstrap
import { Col } from 'react-bootstrap';

import './InfoCustomCard.css';

const heightWindow = window.innerHeight;

const InfoCustomCard = (props) => {
    const [visible, setVisible] = useState(false);

    const handleVisible = useCallback(() => {
        if (visible === false) {
            const posTopElement = document.getElementById(props.id).getBoundingClientRect().y;
            const posBottomElement = posTopElement + (document.getElementById(props.id).getBoundingClientRect().height / 5);
            if ((heightWindow) > (posBottomElement)) {
                setVisible(true);
                window.removeEventListener('scroll', handleVisible, true);
            }
        }
    }, [props.id, visible]);

    useEffect(() => {
        setVisible(heightWindow > (document.getElementById(props.id).getBoundingClientRect().y + (document.getElementById(props.id).getBoundingClientRect().height / 5)));
    }, [props.id]);

    useEffect(() => {
        window.addEventListener('scroll', handleVisible, true);
        return (() => {
            window.removeEventListener('scroll', handleVisible, true);
        });
    }, [handleVisible]);

    const classesVisible = `custom-visible custom-transition-scale p-xl-5 p-lg-4 p-md-3 shadow rounded-lg ${props.classes}`;
    const classesHidden = `custom-visible-hidden p-xl-5 p-lg-4 p-md-3 shadow rounded-lg ${props.classes}`;

    return (
        <Col id={props.id} name={props.id} {...props.flex} className={visible ? classesVisible : classesHidden}>
            {props.timeline ?
                <h5 className="custom-text-black custom-font-weight-bolder mb-4">{props.title}</h5>
                :
                <h3 className="custom-text-black custom-font-weight-bolder mb-4">{props.title}</h3>
            }
            {props.children}
        </Col >
    );
};

export default InfoCustomCard;